import { render, staticRenderFns } from "./welfare-navbar.vue?vue&type=template&id=44d31ebd&scoped=true&lang=pug&"
import script from "./welfare-navbar.vue?vue&type=script&lang=js&"
export * from "./welfare-navbar.vue?vue&type=script&lang=js&"
import style0 from "./welfare-navbar.vue?vue&type=style&index=0&id=44d31ebd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d31ebd",
  null
  
)

export default component.exports